import {FETCH_LOTTERY_SHIFT, LIST_LOTTERY_SHIFT} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: [],
    rows: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOTTERY_SHIFT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_LOTTERY_SHIFT:
            return {
                ...state,
                isLoading: false,
                list: payload,
            };
        default:
            return state;
    }
}